// Configure Long support using require('long');
var $protobuf = require('protobufjs/minimal');
var Long = require('long');
$protobuf.util.Long = Long;
$protobuf.configure();

const { google, ...streemProtobuf } = require('./streem_protobuf');
const Timestamp = google.protobuf.Timestamp;
module.exports = Object.assign({}, streemProtobuf, { Timestamp, Long });
